<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100 d-flex justify-content-between align-items-center"
    >
      <h2 class="title_h">Danh sách TB Boxme</h2>
      <button class="btn btn-outline-secondary" @click="exportExcel">
        <i class="bx bx-download"></i> Xuất file
      </button>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.mnpSerial"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã thiết bị"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.orderNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã đơn hàng"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.packingCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã đóng gói BM"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="filters.dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder"> Thời gian bán </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              :disabled="filters.statusCode && filters.statusCode !== '0'"
              v-model="filters.statusGroup"
              :options="statusGroupOptions"
              placeholder="Nhóm trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              :disabled="filters.statusGroup && filters.statusGroup !== '0'"
              v-model="filters.statusCode"
              :options="orderStatusOptions"
              placeholder="Tình trạng đơn hàng"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.receiverPhone"
              class="form-control f12 hc-37 text-search"
              placeholder="Số điện thoại nhận"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="submit"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div
                v-if="hasDefaultFilter"
                class="mb-2 d-inline-flex align-items-center"
                style="
                  background-color: #fff3e0;
                  padding: 6px 12px;
                  border-radius: 4px;
                  font-size: 13px;
                "
              >
                <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
                <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
                <button
                  @click="removeDefaultFilter"
                  type="button"
                  class="ml-2 btn-close-filter"
                  style="
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 0 4px;
                    color: #e65100;
                    font-size: 16px;
                    line-height: 1;
                  "
                  title="Bỏ lọc"
                >
                  ×
                </button>
              </div>
              <div class="box-header">
                Tổng:
                <strong class="text-primary">&nbsp;{{ pagination.total }}</strong>
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>

              <template #cell(mnpSerial)="{ item }">
                <div>{{ item.mnpSerial }}</div>
              </template>

              <template #cell(receiver)="{ item }">
                <div>
                  <p>{{ item.receiverName }}</p>
                  <p>{{ item.receiverPhone }}</p>
                  <p>
                    {{
                      item.receiverAddress +
                      ', ' +
                      item.receiverSubDistrict +
                      ', ' +
                      item.receiverDistrict +
                      ', ' +
                      item.receiverProvince
                    }}
                  </p>
                </div>
              </template>

              <template #cell(saleCareName)="{ item }">
                <div>{{ item.saleCareName || '' }}</div>
              </template>

              <template #cell(saleCareStatus)="{ item }">
                <div>
                  <span
                    v-if="item.saleCareStatus"
                    :class="`badge ${getSaleCareStatusBadge(item.saleCareStatus)}`"
                  >
                    {{ getSaleCareStatusText(item.saleCareStatus) }}
                  </span>
                  <span v-else class="badge badge-secondary"> Chưa chăm sóc </span>
                </div>
              </template>

              <template #cell(createdAtTime)="{ item }">
                <div>
                  {{
                    new Date(item.createdAtTime).toLocaleDateString('vi-VN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}
                </div>
              </template>

              <template #cell(source)="{ item }">
                <div>
                  {{
                    item.source ? item.source.charAt(0).toUpperCase() + item.source.slice(1) : ''
                  }}
                </div>
              </template>

              <template #cell(orderNumber)="{ item }">
                <div>{{ item.orderNumber }}</div>
              </template>

              <template #cell(packingCode)="{ item }">
                <div>{{ item.packingCode }}</div>
              </template>

              <template #cell(pickupAddress)="{ item }">
                <div class="pickup-address-cell">
                  {{
                    item.pickupAddress
                      ? 'BM ' + (item.pickupAddress.includes('Hà Nội') ? 'HN' : 'HCM')
                      : ''
                  }}
                </div>
              </template>

              <template #cell(shipping)="{ item }">
                <div>
                  <p>{{ item.courierTrackingNumber }}</p>
                  <p>{{ item.externalCourierName }}</p>
                </div>
              </template>

              <template #cell(status)="{ item }">
                <div>
                  <span
                    v-if="item.statusCode"
                    :class="`badge ${getStatusBadgeByCode(item.statusCode)}`"
                  >
                    {{ getStatusGroupByCode(item.statusCode) }}
                  </span>
                  <br />
                  <span
                    v-if="item.warehouseStatusDisplay"
                    :class="`mt-1 badge ${getStatusBadgeByCode(item.statusCode)}`"
                  >
                    {{ item.statusName }}
                  </span>
                </div>
              </template>

              <template #cell(actions)="{ item }">
                <b-dropdown variant="outline-primary" text="" right>
                  <!-- <b-dropdown-item :href="`/boxme/details/${item.mnpSerial}`">
      <i class="bx bx-show"></i> Chi tiết
    </b-dropdown-item> -->
                  <!-- <b-dropdown-divider></b-dropdown-divider> -->
                  <b-dropdown-item
                    v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_BOXME_UPDATE')"
                    @click="openUpdateStaffModal(item)"
                  >
                    <i class="bx bx-user"></i> Cập nhật nhân viên
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_BOXME_UPDATE')"
                    @click="openUpdateStatusModal(item)"
                  >
                    <i class="bx bx-edit"></i> Cập nhật trạng thái
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal cập nhật nhân viên -->
    <b-modal
      ref="updateStaffModal"
      title="Cập nhật nhân viên chăm sóc"
      @ok="updateStaff"
      ok-title="Cập nhật"
      cancel-title="Hủy"
    >
      <div class="form-group">
        <label>Chọn nhân viên:</label>
        <!-- <Select2 v-model="selectedStaffId" :options="staffOptions" placeholder="Chọn nhân viên chăm sóc" /> -->
        <SearchStaffAutocomplete
          :maxShow="20"
          v-model="selectedStaffId"
          :list="staffOptions"
          placeholder="Chọn/Tìm kiếm thiết bị"
        />
      </div>
    </b-modal>

    <!-- Modal cập nhật trạng thái -->
    <b-modal
      ref="updateStatusModal"
      title="Cập nhật trạng thái chăm sóc"
      @ok="updateStatus"
      ok-title="Cập nhật"
      cancel-title="Hủy"
    >
      <div class="form-group">
        <label>Chọn trạng thái:</label>
        <Select2
          v-model="selectedStatus"
          :options="statusCareOptions"
          placeholder="Chọn trạng thái chăm sóc"
        />
      </div>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>
<script>
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import { showMess } from '@/config/utils'
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { CommonService } from '@/services/common.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import moment from 'moment'
  import { getLastNDays } from '@/utils/util'

  export default {
    components: { ModalExportNoti, SearchStaffAutocomplete },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        selectedItem: null,
        selectedStaffId: null,
        selectedStatus: null,
        staffOptions: [],
        statusCareOptions: [
          { id: 'NOT_CARED', text: 'Chưa chăm sóc' },
          { id: 'IN_PROGRESS', text: 'Đang chăm sóc' },
          { id: 'CARED', text: 'Đã hoàn thành' },
        ],

        localeData: {
          // AI
          direction: 'ltr', // AI
          format: 'dd/MM/yyyy', // AI
          separator: ' - ', // AI
          applyLabel: 'Áp dụng', // AI
          cancelLabel: 'Hủy', // AI
          weekLabel: 'T', // AI
          customRangeLabel: 'Tùy chỉnh', // AI
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'], // AI
          monthNames: [
            // AI
            'Tháng 1', // AI
            'Tháng 2', // AI
            'Tháng 3', // AI
            'Tháng 4', // AI
            'Tháng 5', // AI
            'Tháng 6', // AI
            'Tháng 7', // AI
            'Tháng 8', // AI
            'Tháng 9', // AI
            'Tháng 10', // AI
            'Tháng 11', // AI
            'Tháng 12', // AI
          ], // AI
          firstDay: 1, // AI
        }, // AI
        Config, // AI
        filters: {
          dateRange: {
            startDate: from,
            endDate: to,
          },
        },

        dataUser: JSON.parse(localStorage.getItem('userData')), // AI
        statusGroupOptions: [
          // AI
          { id: 0, text: 'Tất cả', bgColor: 'badge-secondary' }, // AI
          { id: ['801', '800', '901'], text: 'Đã giao hàng thành công' }, // AI
          { id: ['400', '410'], text: 'Đang gặp vấn đề' }, // AI
          { id: ['600', '510', '500', '705'], text: 'Chuyển hoàn' }, // AI
          { id: ['700', '702', '605', '703', '701'], text: 'Hủy đơn' }, // AI
          { id: ['304', '301', '280'], text: 'Đang vận chuyển' }, // AI
          { id: ['706', '708'], text: 'Chuẩn bị hàng tại Kho' }, // AI
        ], // AI
        orderStatusOptions: [
          // AI
          { id: 0, text: 'Tất cả', bgColor: 'badge-secondary' }, // AI

          // Nhóm: Đã giao hàng thành công // AI
          { id: 901, text: 'Đã đối soát', bgColor: 'badge-success' }, // AI
          { id: 800, text: 'Phát thành công', bgColor: 'badge-success' }, // AI
          { id: 801, text: 'Hoàn tất đơn hàng', bgColor: 'badge-success' }, // AI

          // Nhóm: Đang gặp vấn đề // AI
          { id: 400, text: 'Phát không thành công', bgColor: 'badge-danger' }, // AI
          { id: 410, text: 'Chờ xác nhận giao lại', bgColor: 'badge-warning' }, // AI

          // Nhóm: Chuyển hoàn // AI
          { id: 600, text: 'Hoàn thành công', bgColor: 'badge-warning' }, // AI
          {
            // AI
            id: 510, // AI
            text: 'Phát hoàn không thành công', // AI
            bgColor: 'badge-danger', // AI
          }, // AI
          { id: 500, text: 'Đang chuyển hoàn', bgColor: 'badge-warning' }, // AI
          { id: 705, text: 'Hủy đơn khi xuất kho', bgColor: 'badge-warning' }, // AI
          // Nhóm: Hủy đơn // AI
          { id: 700, text: 'Đơn hủy bởi khách hàng', bgColor: 'badge-danger' }, // AI
          { id: 702, text: 'Đơn hủy bởi đối tác', bgColor: 'badge-danger' }, // AI
          { id: 605, text: 'Hủy hàng tại nơi phát', bgColor: 'badge-warning' }, // AI
          { id: 703, text: 'Đơn hủy bởi hệ thống', bgColor: 'badge-danger' }, // AI
          { id: 701, text: 'Đơn hủy bởi vận hành', bgColor: 'badge-danger' }, // AI
          // Nhóm: Đang vận chuyển // AI
          { id: 304, text: 'Đang vận chuyển', bgColor: 'badge-info' }, // AI
          { id: 301, text: 'Đã bàn giao', bgColor: 'badge-success' }, // AI
          { id: 280, text: 'Chờ bàn giao', bgColor: 'badge-info' }, // AI
          // Nhóm: Cbi hàng tại Kho // AI
          { id: 706, text: 'Chờ hủy tại kho', bgColor: 'badge-warning' }, // AI
          { id: 708, text: 'Huỷ do thất lạc', bgColor: 'badge-danger' }, // AI
          { id: 240, text: 'Đã đóng gói', bgColor: 'badge-info' }, // AI
        ], // AI
        sourceOptions: [
          // AI
          { id: 'lazada', text: 'Lazada' }, // AI
          { id: 'shopee', text: 'Shopee' }, // AI
          { id: 'tiktok', text: 'TikTok' }, // AI
          { id: 'other', text: 'Khác' }, // AI
        ], // AI
        isLoading: true, // AI
        fields: [
          // AI
          { key: 'mnpSerial', label: 'Mã thiết bị', sortable: false }, // AI
          { key: 'receiver', label: 'Người nhận', sortable: false }, // AI
          { key: 'createdAtTime', label: 'Thời gian bán', sortable: false }, // AI
          { key: 'source', label: 'Nguồn shop', sortable: false }, // AI
          { key: 'orderNumber', label: 'Mã đơn hàng', sortable: false }, // AI
          { key: 'platformOrderNumber', label: 'Mã đóng gói (Boxme)', sortable: false }, // AI
          { key: 'packingCode', label: 'Mã vận đơn BM', sortable: false }, // AI
          { key: 'pickupAddress', label: 'Kho pickup', sortable: false }, // AI
          { key: 'shipping', label: 'Vận đơn', sortable: false }, // AI
          { key: 'status', label: 'Tình trạng', sortable: false }, // AI
          { key: 'saleCareName', label: 'Nhân viên phụ trách', sortable: false }, // AI
          { key: 'saleCareStatus', label: 'Trạng thái chăm sóc', sortable: false }, // AI
          { key: 'actions', label: 'Hành động', sortable: false }, // AI
        ], // AI
        pagination: {
          // AI
          page: 1, // AI
          limit: 20, // AI
          total: 10, // AI
        }, // AI
        dataTable: [
          // AI
        ],
        hasDefaultFilter: true,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      // AI
      this.getListStaffBySuperior() // AI
      this.transformDate()
      this.fetchData() // AI
    },
    methods: {
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.data.length > 0) {
            this.staffOptions = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 4. Thêm methods mới:
      openUpdateStaffModal(item) {
        this.selectedItem = item
        this.selectedStaffId = item.saleCareId || null
        this.$refs.updateStaffModal.show()
      },

      openUpdateStatusModal(item) {
        this.selectedItem = item
        this.selectedStatus = item.saleCareStatus || 'NOT_CARED'
        this.$refs.updateStatusModal.show()
      },
      async updateStaff() {
        if (!this.selectedStaffId || !this.selectedItem) {
          showMess(this, 'Lỗi', 'Vui lòng chọn nhân viên', 'danger', 'b-toaster-top-right', 5000)
          return
        }

        try {
          const payload = {
            orderNumber: this.selectedItem.orderNumber,
            saleCareId: this.selectedStaffId,
          }

          // Gọi API cập nhật nhân viên - thay thế bằng service thực tế
          const res = await DeviceService.updateSaleCare(payload)

          if (res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Cập nhật nhân viên thành công',
              'success',
              'b-toaster-top-right',
              5000
            )
            this.fetchData() // Reload data
          }
        } catch (error) {
          showMess(
            this,
            'Lỗi',
            error.response?.data?.message || 'Có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            5000
          )
        }
      },

      async updateStatus() {
        if (!this.selectedStatus || !this.selectedItem) {
          showMess(this, 'Lỗi', 'Vui lòng chọn trạng thái', 'danger', 'b-toaster-top-right', 5000)
          return
        }

        try {
          const payload = {
            orderNumber: this.selectedItem.orderNumber,
            saleCareStatus: this.selectedStatus,
          }

          // Gọi API cập nhật trạng thái - thay thế bằng service thực tế
          const res = await DeviceService.updateCareStatus(payload)

          if (res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Cập nhật trạng thái thành công',
              'success',
              'b-toaster-top-right',
              5000
            )
            this.fetchData() // Reload data
          }
        } catch (error) {
          showMess(
            this,
            'Lỗi',
            error.response?.data?.message || 'Có lỗi xảy ra',
            'danger',
            'b-toaster-top-right',
            5000
          )
        }
      },

      // AI
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      filterInvalidData(data) {
        if (!data || typeof data !== 'object') {
          return {}
        }

        const result = { ...data }
        let hasInvalidValues = false

        for (const key in result) {
          const value = result[key]

          // Xử lý nếu là chuỗi phân tách bằng dấu phẩy
          if (typeof value === 'string' && value.includes(',')) {
            const parts = value.split(',').map(part => part.trim())
            const newParts = parts.map(part =>
              part === '0' || part === '' || part === 'null' || part === 'undefined' ? '' : part
            )
            result[key] = newParts
            hasInvalidValues = true
          } else if (value === null || value === undefined || value === '0' || value === '') {
            delete result[key]
            hasInvalidValues = true
          }
        }

        return hasInvalidValues ? result : data
      },

      submitForm() {
        // AI
        this.pagination.page = 1 // AI
        this.fetchData() // AI
      },
      getSaleCareStatusBadge(status) {
        const statusMap = {
          NOT_CARED: 'badge-secondary',
          IN_PROGRESS: 'badge-warning',
          CARED: 'badge-success',
        }
        return statusMap[status] || 'badge-secondary'
      },

      getSaleCareStatusText(status) {
        const statusMap = {
          NOT_CARED: 'Chưa chăm sóc',
          IN_PROGRESS: 'Đang chăm sóc',
          CARED: 'Đã hoàn thành',
        }
        return statusMap[status] || 'Chưa chăm sóc'
      },
      async exportExcel() {
        // AI
        try {
          // AI
          this.showLoading = true // AI
          const payload = {
            ...this.filterInvalidData(this.filters), // AI
            page: this.pagination.page, // AI
            limit: this.pagination.limit, // AI
          } // AI
          const body = {
            // AI
            object: payload, // AI
            type: 'CNPS_DEVICE_BOXME', // AI
          } // AI
          const data = await CommonService.receiveFile(body) // AI
          if (data.success) {
            // AI
            this.openModalLoadFile(data.data.id) // AI
          } // AI
        } catch (error) {
          // AI
          console.log(error) // AI
        } finally {
          // AI
          this.showLoading = false // AI
        } // AI
      }, // AI

      clearSearch() {
        // AI
        this.filters = {
          dateRange: {
            // AI
            startDate: null,
            endDate: null,
          }, // AI
        } // AI
        this.pagination.page = 1 // AI
        this.hasDefaultFilter = false
        this.fetchData() // AI
      }, // AI
      transformDate() {
        if (
          this.filters.dateRange &&
          this.filters.dateRange.startDate &&
          this.filters.dateRange.endDate
        ) {
          this.filters.createdAtFrom = moment(this.filters.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()
          this.filters.createdAtTo = moment(this.filters.dateRange.endDate)
            .endOf('day')
            .add(7, 'hours')
            .valueOf()
        } else {
          this.filters.createdAtFrom = null
          this.filters.createdAtTo = null
        }
      },

      removeDefaultFilter() {
        this.filters = {
          dateRange: {
            startDate: null,
            endDate: null,
          },
        }
        this.hasDefaultFilter = false
        this.pagination.page = 1
        this.fetchData()
      },
      async fetchData() {
        // AI
        try {
          // AI
          this.isLoading = true // AI
          const payload = this.filterInvalidData(this.filters) // AI
          if (payload.statusGroup?.length > 0) {
            payload.statusCode = payload.statusGroup // AI.
            delete payload.statusGroup
          }
          if (typeof payload.statusCode === 'string') {
            payload.statusCode = [payload.statusCode]
          }
          // Replace with actual API call // AI
          const res = await DeviceService.getListDeviceBoxme({
            // AI
            ...payload, // AI
            page: this.pagination.page, // AI
            limit: this.pagination.limit, // AI
          }) // AI

          if (res.code === 1000) {
            // AI
            this.dataTable = res.data.boxmes || [] // AI
            this.pagination.total = res.data.count ?? 0 // AI
          } // AI
        } catch (error) {
          // AI
          showMess(
            // AI
            this, // AI
            'Error', // AI
            error.response?.data?.message || // AI
              error.response?.message || // AI
              error.message, // AI
            'danger', // AI
            'b-toaster-top-right', // AI
            5 * 60 * 60 // AI
          ) // AI
        } finally {
          // AI
          this.isLoading = false // AI
        } // AI
      }, // AI
      onChangePage(pageIndex) {
        // AI
        this.pagination.page = pageIndex // AI
        this.fetchData() // AI
      }, // AI
      getStatusBadgeByCode(code) {
        // AI
        const statusMap = {
          // AI
          // Nhóm: Đang gặp vấn đề
          400: 'badge-danger', // AI
          410: 'badge-warning', // AI
          // Nhóm: Chuyển hoàn
          600: 'badge-warning', // AI
          510: 'badge-danger', // AI
          500: 'badge-warning', // AI
          705: 'badge-warning', // AI
          // Nhóm: Hủy đơn
          700: 'badge-danger', // AI
          702: 'badge-danger', // AI
          605: 'badge-warning', // AI
          703: 'badge-danger', // AI
          701: 'badge-danger', // AI
          // Nhóm: Đang vận chuyển
          304: 'badge-info', // AI
          301: 'badge-success', // AI
          280: 'badge-info', // AI
          // Nhóm: Cbi hàng tại Kho
          706: 'badge-warning', // AI
          708: 'badge-danger', // AI
          240: 'badge-info', // AI
          // Mặc định // AI
          3: 'badge-success', // Handed over // AI
          800: 'badge-success', // Handed over // AI
          801: 'badge-success', // Handed over // AI
          901: 'badge-success', // Handed over // AI
        } // AI

        return statusMap[code] || 'badge-secondary' // AI
      }, // AI
      getStatusGroupByCode(code) {
        console.log('code', code)
        // AI
        if (code === 400 || code === 410) {
          // AI
          return 'Đang gặp vấn đề' // AI
        } else if ([600, 510, 500, 705].includes(code)) {
          // AI
          return 'Chuyển hoàn' // AI
        } else if ([700, 702, 605, 703, 701].includes(code)) {
          // AI
          return 'Đã giao hàng thành công' // AI
        } else if ([801, 303, 901].includes(code)) {
          // AI
          return 'Hủy đơn' // AI
        } else if ([801, 800, 901].includes(code)) {
          // AI
          return 'Đã giao hàng thành công' // AI
        } else if ([304, 301, 280].includes(code)) {
          // AI
          return 'Đang vận chuyển' // AI
        } else if ([706, 708, 240].includes(code)) {
          // AI
          return 'Chuẩn bị hàng tại Kho' // AI
        } // AI

        return '' // AI
      }, // AI
    }, // AI
  } // AI
</script>
<style scoped></style>
